import { useUserStore } from "@/store/user";
import { UserWalletType } from "@/types/user";
import { useCallback, useEffect, useState } from "react";

export const useGetWallets = () => {
  const [walletsData, setWalletsData] = useState<{
    solana_wallets_count: number;
    aptos_wallets_count: number;
    walletAddresses: UserWalletType[];
  }>();
  const fetchWalletAddresses = useUserStore((state) => state.fetchWalletAddresses);

  const getWallets = useCallback(async () => {
    try {
      const walletAddresses = await fetchWalletAddresses();
      setWalletsData({
        solana_wallets_count: walletAddresses["solana_addresses"]?.length || 0,
        aptos_wallets_count: walletAddresses["aptos_addresses"]?.length || 0,
        walletAddresses: [
          ...(walletAddresses["solana_addresses"] || []),
          ...(walletAddresses["aptos_addresses"] || [])
        ]
      });
    } catch (e) {
      console.log(e);
    }
  }, [fetchWalletAddresses]);

  useEffect(() => {
    getWallets();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    walletsData,
    getWallets
  };
};
